<template>
    <div>
        <div class="col-lg-8 px-0 mt-4">
            <ul class="input-table">
                <li
                    class="d-flex justify-content-start"
                    v-if="items.length"
                    v-for="(item, index) in items"
                    :key="item.id"
                >
                    <div class="input-table-shadow">
                        <div class="d-flex row align-items-center">
                            <div class="col-5 pl-5 border-right">
                                <core-date-range-calendar
                                    :start.sync="item.dateFrom"
                                    :end.sync="item.dateUntil"
                                ></core-date-range-calendar>
                            </div>
                            <div class="col-5 border-right">
                                <core-days-modal-picker
                                    :days.sync="item.arrivalDays"
                                ></core-days-modal-picker>
                            </div>
                            <div class="col pl-3">
                                <input type="text" placeholder="season" v-model="item.code">
                            </div>
                        </div>
                    </div>
                    <div class="pl-2 d-flex align-items-center">
                        <core-icon
                            @click.native="clone(item)"
                            class="pointer"
                            :iconName="$t('general.clone')"
                            iconColor="#bdbdbd"
                        >
                            <icons-clone></icons-clone>
                        </core-icon>
                    </div>
                    <div class="pl-1 d-flex align-items-center">
                        <core-icon
                            @click.native="remove(index)"
                            class="pointer"
                            :iconName="$t('general.remove')"
                            iconColor="#bdbdbd"
                        >
                            <icons-delete></icons-delete>
                        </core-icon>
                    </div>
                </li>
            </ul>
        </div>
        <img
            class="ml-3 add-row"
            src="@/assets/svg/plus008CDD.svg"
            @click="add"
            :title="$t('general.add')"
        >
    </div>
</template>

<script>
import Season from '@/services/hatsApi/Season'
import { addItem } from '@/mixins/addItem'
import { cloneItem } from '@/mixins/cloneItem'
import { removeItem } from '@/mixins/removeItem'

export default {
  data () {
    return {
      items: this.seasons,
      searchQuery: null,
      serviceType: null,
      dateDisplayFormat: 'DD-MM-YYYY',
      serviceId: null
    }
  },
  props: {
    seasons: {
      default: () => ([]),
      type: Array,
      required: false
    }
  },
  mixins: [addItem, cloneItem, removeItem],
  created () {
    this.serviceType = this.$route.params.service_type
    this.serviceId = this.$route.params.id
    let filters = [
      {
        property: 'serviceId',
        value: this.serviceId
      }
    ]
    Season.getSeasons(filters).then((response) => {
      this.items = response.data.data
      if (!this.items.length) {
        this.add()
      }
    })
  },
  watch: {
    items (val) {
      this.$emit('update:seasons', val)
    }
  }
}
</script>

<style>
    vdpArrowPrev:after {
        border-right-color: #0099E5;
    }

    .vdpArrowNext:after {
        border-left-color: #0099E5;
    }

    .vdpCell.selectable:hover .vdpCellContent,
    .vdpCell.selected .vdpCellContent {
        background: #008CDD;
    }

    .vdpCell.today {
        color: #008CDD;
    }

    .vdpTimeUnit > input:hover,
    .vdpTimeUnit > input:focus {
        border-bottom-color: #0099E5;
    }
</style>



// WEBPACK FOOTER //
// src/components/SeasonsInputTable.vue